/*
 * Copyright 2019 FedEx
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

type NewType = any;

@Injectable({
  providedIn: 'root'
})
export class LanguageTranslationService {

  lang_data: NewType = {};
  constructor(private httpObj: HttpClient) { }

  useLang(lang: string, country: string): Promise<{}> {
    return new Promise<{}>(
      (resolve, _reject) => {
        const languageCountry = lang.toLowerCase() + '-' + country.toUpperCase();
        const langFilePath = `assets/lang/${languageCountry || 'en-NL'}.json`;
        this.httpObj.get<{}>(langFilePath).subscribe(
          translationData => {
            this.lang_data = Object.assign({}, translationData || {});
            resolve(this.lang_data);
          },
          error => {
            resolve(this.lang_data);
            console.log(error);
          }
        );
      }
    );
  }
}
